import React from "react";
import { Link } from "react-router-dom";

export default function Landing() {
  return (
    <div className="min-h-screen grain" data-testid="landing-page">
      {/* Nav */}
      <nav className="container-editorial pt-8 pb-4 flex justify-between items-center">
        <Link
          to="/"
          className="font-serif-display text-2xl md:text-3xl tracking-tight"
          data-testid="brand-logo"
        >
          Aesthos<span className="text-[color:var(--terracotta)]">.</span>
        </Link>
        <div className="flex items-center gap-6 md:gap-10 overline">
          <Link to="/quiz" data-testid="nav-quiz" className="hover:text-[color:var(--ink)]">Quiz</Link>
          <Link to="/admin" data-testid="nav-admin" className="hover:text-[color:var(--ink)]">Admin</Link>
        </div>
      </nav>

      <div className="hairline container-editorial" style={{ maxWidth: "auto" }} />

      {/* Hero */}
      <section className="container-editorial pt-16 md:pt-24 pb-20 md:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7 fade-up">
            <p className="overline mb-6" data-testid="hero-eyebrow">Chapter 01 — The Style DNA Quiz</p>
            <h1
              className="font-serif-display text-5xl sm:text-6xl md:text-7xl lg:text-[7rem] leading-[0.95] tracking-tight text-[color:var(--ink)]"
              data-testid="hero-headline"
            >
              Discover the
              <br />
              <em className="italic font-normal text-[color:var(--terracotta)]">interiors</em>
              <br />
              you were born
              <br />
              to live in.
            </h1>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 fade-up" style={{ animationDelay: "0.2s" }}>
            <p className="text-base md:text-lg leading-relaxed text-[color:var(--ink-soft)] mb-8" data-testid="hero-subtext">
              A visual, low-friction quiz. Choose the eight rooms that stop you.
              We&rsquo;ll return your <span className="italic text-[color:var(--ink)]">Design DNA</span>—the
              primary and secondary styles that quietly shape what you love.
            </p>
            <Link to="/quiz" data-testid="start-quiz-button" className="btn-primary">
              Begin the quiz
              <span aria-hidden>→</span>
            </Link>
            <p className="overline mt-6">Takes 90 seconds · No sign-up</p>
          </div>
        </div>
      </section>

      {/* Editorial strip */}
      <section className="container-editorial pb-24 md:pb-32">
        <div className="hairline mb-12" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          {[
            { n: "01", t: "Browse", d: "A curated shuffled grid of interiors — from Japandi to Indo Portuguese." },
            { n: "02", t: "Select 8", d: "Pick eight images that pull you in. No thinking. Just instinct." },
            { n: "03", t: "Reveal", d: "See your primary + secondary style, signature traits, materials and palette." },
          ].map((s) => (
            <div key={s.n} className="fade-up">
              <p className="font-serif-display text-6xl md:text-7xl text-[color:var(--terracotta)] mb-2">{s.n}</p>
              <h3 className="font-serif-display text-2xl md:text-3xl mb-3">{s.t}</h3>
              <p className="text-sm md:text-base text-[color:var(--ink-soft)] leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Style ticker */}
      <section className="container-editorial pb-32">
        <div className="hairline mb-12" />
        <p className="overline mb-6">Twelve styles · One DNA</p>
        <div className="font-serif-display text-2xl md:text-4xl lg:text-5xl leading-tight text-[color:var(--ink)]" data-testid="style-list">
          Bohemian <span className="text-[color:var(--ink-soft)]">·</span> Contemporary{" "}
          <span className="text-[color:var(--ink-soft)]">·</span> French Classical{" "}
          <span className="text-[color:var(--ink-soft)]">·</span> French Contemporary{" "}
          <span className="text-[color:var(--ink-soft)]">·</span> Indo Portuguese{" "}
          <span className="text-[color:var(--ink-soft)]">·</span> Industrial{" "}
          <span className="text-[color:var(--ink-soft)]">·</span>{" "}
          <em className="italic text-[color:var(--terracotta)]">Japandi</em>{" "}
          <span className="text-[color:var(--ink-soft)]">·</span> Luxury{" "}
          <span className="text-[color:var(--ink-soft)]">·</span> North East Indian{" "}
          <span className="text-[color:var(--ink-soft)]">·</span> North Indian{" "}
          <span className="text-[color:var(--ink-soft)]">·</span> South Indian{" "}
          <span className="text-[color:var(--ink-soft)]">·</span> West Indian.
        </div>
      </section>

      <footer className="container-editorial pb-10">
        <div className="hairline mb-6" />
        <p className="overline">© Aesthos — Design DNA Quiz</p>
      </footer>
    </div>
  );
}
